import React from 'react';
import styled from 'styled-components';

const InfoDisplayStyle = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	padding-left: 15px;
	padding-right: 15px;
	background: ${props => props.theme.white};
	color: ${props => props.theme.defaultFontColor};
	.info-item {
		width: 100%;
		display: flex;
		height: 30px;
		align-items: center;
		border-bottom: 1px solid ${props => props.theme.Cool_Gray_Light_3};
		.label {
			width: 75px;
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		padding-left: 30px;
		padding-right: 30px;

		.info-item {
			height: 40px;

			.label {
				width: 125px;
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		padding-left: 30px;
		padding-right: 30px;

		.info-item {
			height: 60px;

			.label {
				width: 150px;
			}
		}
	}
`;

export const InfoDisplay = ({ id, info }) => {
	return (
		<InfoDisplayStyle id={`info-display-${id}`} className='info-display' data-cy='info-display'>
			{info &&
				info.map(item => (
					<div className='info-item'>
						<div className='label labels21'>{item.label}</div>
						<div className='value body10'>{item.value}</div>
					</div>
				))}
		</InfoDisplayStyle>
	);
};
